<template>
  <div class="parent">
    <div class="box">
      <h1>AgilPedido</h1>
      <a @click.prevent="backToLanding" class="delete is-medium"></a>

      <div class="encabezado">
        <h2>
          {{ I18n.titulo }}
          <i class="fa fa-magic"></i>
        </h2>

        <progress v-if="paso > 0" :value="paso" max="3" class="progress is-primary"></progress>
      </div>

      <div v-if="responseErrors.length" class="notification is-warning">
        <ul class="errores">
          <li v-for="error in responseErrors">
            <i class="fa fa-caret-right"></i>
            {{ error }}
          </li>
        </ul>
      </div>

      <component :is="activeView" :tienda="tienda" @updateValida="seccionValida = $event" />

      <div class="botonera">
        <button
          v-if="paso > 0 && paso < 3"
          @click="regresarPaso"
          class="button is-primary anterior"
        >
          <i class="fa fa-arrow-alt-circle-left fa-lg"></i>
          {{ I18n.anterior }}
        </button>
        <button
          v-if="paso < 2"
          :disabled="!seccionValida"
          @click="proximoPaso"
          class="button is-primary siguiente"
        >
          {{ I18n.siguiente }}
          <i class="fa fa-arrow-alt-circle-right fa-lg"></i>
        </button>
        <button
          v-if="paso == 2"
          :disabled="!seccionValida"
          @click="onFinalizarClick"
          class="button is-primary finalizar"
        >
          <i class="fa fa-check fa-lg"></i>
          {{ I18n.crear_tienda }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import DatosRegistro from '@src/registro/datos_registro.vue'
import DatosOperativos from '@src/registro/datos_operativos.vue'
import DatosCabecera from '@src/registro/datos_cabecera.vue'
import GenerandoTienda from '@src/registro/generando_tienda.vue'

export default {
  components: { DatosRegistro, DatosOperativos, DatosCabecera, GenerandoTienda },

  data() {
    return {
      tienda: {
        pais: serverExports.pais,
        nombre_fantasia: '',
        email: '',
        password: '',
        password_confirmation: '',
        tienda: '',
        nombre: '',
        whatsapp: '',
        costo_envio: 0,
        localidad: '',
        contacto_telefono: '',
        contacto_nombre: '',
        instagram: ''
      },

      paso: 0,
      seccionValida: false,
      responseErrors: [],

      I18n: serverExports.I18n
    }
  },

  computed: {
    activeView() {
      return [DatosRegistro, DatosOperativos, DatosCabecera, GenerandoTienda][this.paso]
    }
  },

  methods: {
    backToLanding() {
      if (window['gtag'])
        gtag('event', 'cerrar-alta', {
          event_category: 'suscripcion',
          event_label: this.tienda.pais
        })
      window.location.replace(`/${this.tienda.pais}`)
    },

    proximoPaso() {
      this.paso += 1
      this.seccionValida = false
      if (window['gtag'])
        gtag('event', `ir-a-paso-${this.paso}`, {
          event_category: 'suscripcion',
          event_label: this.tienda.pais
        })
    },

    regresarPaso() {
      this.paso -= 1
      this.seccionValida = true
      if (window['gtag'])
        gtag('event', `volver-a-paso-${this.paso}`, {
          event_category: 'suscripcion',
          event_label: this.tienda.pais
        })
    },

    onFinalizarClick() {
      this.paso += 1
      axios
        .post('/registrar-tienda', { tienda: this.tienda })
        .then((response) => {
          if (window['gtag'])
            gtag('event', 'tienda-creada', {
              event_category: 'suscripcion',
              event_label: this.tienda.pais
            })
          window.location.replace(`/${this.tienda.tienda}/panel_control`)
        })
        .catch((exception) => {
          if (window['gtag'])
            gtag('event', 'error-al-crear', {
              event_category: 'suscripcion',
              event_label: this.tienda.pais
            })
          if (exception.response && exception.response.data && exception.response.data.errors)
            this.responseErrors = exception.response.data.errors
          this.paso = 0
        })
    }
  }
}
</script>

<style scoped lang="scss">
h1 {
  font-family: 'Lobster', cursive;
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 1rem;
}

h2 {
  font-size: 1.5rem;
  line-height: 1.125;
  font-weight: 600;
  color: #363636;
  margin-bottom: 1.5rem;
}

.parent {
  display: flex;
  justify-content: center;

  @media (max-width: 550px) {
    min-height: 100vh;
  }
}

.encabezado {
  text-align: center;
  margin-bottom: 1.5rem;

  i.fa {
    margin-left: 0.25rem;
  }

  .progress {
    margin-top: 1.5rem;
  }
}

.box {
  padding: 1.75rem 2rem;
  position: relative;

  @media (min-width: 550px) {
    width: 500px;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  @media (max-width: 550px) {
    width: 100%;
    margin-top: 0;
    min-height: 100%;
    border-radius: 0;
  }
}

.delete {
  position: absolute;
  right: 1rem;
  top: 1rem;
}

.notification {
  padding: 1rem 1.25rem;
}

.errores {
  i.fa {
    margin-right: 0.25rem;
  }

  li:nth-child(n + 2) {
    margin-top: 0.5rem;
  }
}

.botonera {
  text-align: center;
  margin-top: 1.5rem;

  button.anterior {
    margin-right: 0.5rem;

    i.fa {
      margin-right: 0.5rem;
    }
  }

  button.siguiente i.fa {
    margin-left: 0.5rem;
  }

  button.finalizar i.fa {
    margin-right: 0.5rem;
  }
}
</style>
